import PropTypes from "prop-types";
import VisualCategoryHeaderLinks from "./VisualCategoryHeaderLinks";
import useVisualCategoryHeaderLinks from "./useVisualCategoryHeaderLinks";
import HorizontalScrollList from "../../../../../HorizontalScrollList";
import Pill from "../../../../Pill";
import styles from "../../../CategoryHeaderLinks";

const CategoryHeaderLinks = ({ childLinks }) => {
  const showVisualCategoryLinks = useVisualCategoryHeaderLinks();

  if (showVisualCategoryLinks) return <VisualCategoryHeaderLinks />;

  return (
    <HorizontalScrollList
      scrollSnapping={false}
      className={styles.categoryHeaderLinks}
    >
      {childLinks.map(({ friendlyName, linkUrl }) => (
        <Pill
          key={friendlyName}
          friendlyName={friendlyName}
          linkUrl={linkUrl}
        />
      ))}
    </HorizontalScrollList>
  );
};

CategoryHeaderLinks.propTypes = {
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired,
      imageUrl: PropTypes.string
    })
  )
};

export default CategoryHeaderLinks;
